var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUserFilled = function SvgUserFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 14a9.01 9.01 0 0 1 9 9 1 1 0 0 1-1 1H4a1 1 0 0 1-1-1 9.01 9.01 0 0 1 9-9M12 0a6 6 0 1 1 0 12 6 6 0 0 1 0-12"
  })));
};
export default SvgUserFilled;